$(document).ready(function () {
    const ajaxPathCreateAccountingExportFile = '/action/accounting/create-accounting-export-file';
    const ajaxPathGetExportLogHtml = '/action/accounting/get-export-log-html';
    const ajaxPathDeleteExportLogs = '/action/accounting/export-logs';
    const ajaxPathSalesPerDayPerProductReport = '/action/report/excel/sales-per-day-per-product';
    const ajaxPathKeySalesNumbersReport = '/action/report/excel/key-sales-numbers';
    const ajaxPathHourlySaleInPeriodReport = '/action/report/excel/hourly-sale-in-period';
    const ajaxPathSalePerRegisterPerDayReport = '/action/report/excel/sale-per-register-per-day';
    const ajaxPathSalesPerRegisterPerZReport = '/action/report/excel/sales-per-register-per-z-report';
    const ajaxPathTotalProductSales = '/action/report/excel/total-product-sales-with-price-levels';
    const ajaxPathScheduleExcelReport = '/action/report/excel/schedule-excel-report';
    var defaultAjaxPath = "/includes/eksport/ajax.php";
    var ajaxLockActive = false;
    var modalParentElementInDOM = $('div#content');
    var modalTitle = '';
    var modalMessage = '';
    var modalButtonText = 'Lukk';
    var modalAlertType = '';

    $(function () {
        $("#sortable1, #sortable2").sortable({
            connectWith: ".connectedSortable"
        }).disableSelection();
    });

    // export products
    $("a#export_products_data").click(function () {
        $.post(defaultAjaxPath, {action: "export_products"},
            function (path) {
                downloadExcelFile(path);
            });
    });

    // export customers
    $("a#export_customers_data").click(function () {
        $.post(defaultAjaxPath, {action: "export_customers"},
            function (path) {
                downloadExcelFile(path);
            });
    });

    // Export customer groups
    $("a#export_customer_groups_data").click(function () {
        $.post(defaultAjaxPath, {action: "export_customer_groups"},
            function (path) {

                downloadExcelFile(path);
            });
    });

    // export suppliers
    $("a#export_suppliers_data").click(function () {
        $.post(defaultAjaxPath, {action: "export_suppliers"},
            function (path) {
                downloadExcelFile(path);
            });
    });

    // export users
    $("a#export_users_data").click(function () {
        $.post(defaultAjaxPath, {action: "export_users"},
            function (path) {
                downloadExcelFile(path);
            });
    });

    // export groups
    $("a#export_groups_data").click(function () {
        $.post(defaultAjaxPath, {action: "export_groups"},
            function (path) {
                downloadExcelFile(path);
            });
    });

    //export report
    $("form#excel_report_form a#fetch_excel_report").click(function () {
        if (ajaxLockActive) {
            return;
        }
        var from = $("form#excel_report_form input#export_date_from").val();
        var to = $("form#excel_report_form input#export_date_to").val();

        if (isDateIntervalToLarge(from, to, 366)) {
            alert("Intervallet du har valgt er større enn 1 år. Vennligst velg et kortere intervall, opp til og med 1 år.")
            return;
        }

        var syncCode = -1;
        if ($("form#excel_report_form select#department_select").val() !== undefined) {
            syncCode = $("form#excel_report_form select#department_select").val();
        }
        ajaxLockActive = true;
        $.post(defaultAjaxPath, {action: "export_report", from: from, to: to, sync_code: syncCode},
            function (path) {
                ajaxLockActive = false;
                downloadExcelFile($.trim(path));
            });
        return false;
    });

    $("form#excel_report_form a#fetch_excel_report_hourly_sale").click(function () {
        if (ajaxLockActive) {
            return;
        }
        var from = $("form#excel_report_form input#export_date_from").val();
        var to = $("form#excel_report_form input#export_date_to").val();
        if (isDateIntervalToLarge(from, to, 366)) {
            alert("Intervallet du har valgt er større enn 1 år. Vennligst velg et kortere intervall, opp til og med 1 år.")
            return;
        }

        var syncCode = -1;
        if ($("form#excel_report_form select#department_select").val() !== undefined) {
            syncCode = $("form#excel_report_form select#department_select").val();
        }
        ajaxLockActive = true;
        $.post(defaultAjaxPath, {action: "export_report_hourly_sale", from: from, to: to, sync_code: syncCode},
            function (path) {
                ajaxLockActive = false;
                downloadExcelFile($.trim(path));
            });
        return false;
    });

    $("form#excel_report_form a#fetch_excel_report_per_register_per_day").click(function () {
        if (ajaxLockActive) {
            return;
        }
        var from = $("form#excel_report_form input#export_date_from").val();
        var to = $("form#excel_report_form input#export_date_to").val();
        if (isDateIntervalToLarge(from, to, 366)) {
            alert("Intervallet du har valgt er større enn 1 år. Vennligst velg et kortere intervall, opp til og med 1 år.")
            return;
        }

        var syncCode = -1;
        if ($("form#excel_report_form select#department_select").val() !== undefined) {
            syncCode = $("form#excel_report_form select#department_select").val();
        }
        ajaxLockActive = true;
        $.post(defaultAjaxPath, {action: "export_report_per_register_per_day", from: from, to: to, sync_code: syncCode},
            function (path) {
                ajaxLockActive = false;
                downloadExcelFileFromReportFolder($.trim(path));
            });
        return false;
    });

    $("form#excel_report_form a#fetch_excel_report_per_register_per_z").click(function () {
        if (ajaxLockActive) {
            return;
        }
        var from = $("form#excel_report_form input#export_date_from").val();
        var to = $("form#excel_report_form input#export_date_to").val();
        if (isDateIntervalToLarge(from, to, 366)) {
            alert("Intervallet du har valgt er større enn 1 år. Vennligst velg et kortere intervall, opp til og med 1 år.")
            return;
        }

        var syncCode = -1;
        if ($("form#excel_report_form select#department_select").val() !== undefined) {
            syncCode = $("form#excel_report_form select#department_select").val();
        }
        ajaxLockActive = true;
        $.post(defaultAjaxPath, {action: "export_report_per_register_per_z", from: from, to: to, sync_code: syncCode},
            function (path) {
                ajaxLockActive = false;
                downloadExcelFileFromReportFolder($.trim(path));
            });
        return false;
    });

    $('form#excel_report_form div#download_excel_report').click(function () {
        if (ajaxLockActive) {
            return;
        }

        var syncCode = -1;
        if ($("form#excel_report_form select#department_select").val() !== undefined) {
            syncCode = $("form#excel_report_form select#department_select").val();
        }

        let scheduleReport = false;
        if ($("input#excel_report_email_recipient").length) {
            scheduleReport = true;
        }

        const data = {};


        let from = $("form#excel_report_form input#export_date_from").val();
        let to = $("form#excel_report_form input#export_date_to").val();
        let selectedReport = $("form#excel_report_form select#excel_report_type").val();
        let customerGroup = $('select#export_customer_group option:selected').val();
        let maxDateInterval = 366;
        let ajaxPath = defaultAjaxPath;
        let errorMessageTooLargeInterval = "Intervallet du har valgt er større enn 1 år. Vennligst velg et kortere intervall, opp til og med 1 år.";

        if (scheduleReport) {
            ajaxPath = ajaxPathScheduleExcelReport
        }else if (selectedReport === 'sale_per_day_per_product') {
            maxDateInterval = 92; //(31 + 30 + 31)
            errorMessageTooLargeInterval = "Intervallet du har valgt er større enn 3 måneder, vennligst velg et kortere intervall, opp til 3 måneder."
            ajaxPath = ajaxPathSalesPerDayPerProductReport;
        } else if (selectedReport === 'key_sales_numbers') {
            ajaxPath = ajaxPathKeySalesNumbersReport;
        } else if (selectedReport === 'hourly_sale') {
            ajaxPath = ajaxPathHourlySaleInPeriodReport;
        } else if (selectedReport === 'sales_per_register_per_day') {
            ajaxPath = ajaxPathSalePerRegisterPerDayReport;
        } else if (selectedReport === 'sales_per_register_per_z_report') {
            ajaxPath = ajaxPathSalesPerRegisterPerZReport;
        } else if (selectedReport === 'product_sales') {
            ajaxPath = ajaxPathTotalProductSales;
        }

        if (selectedReport === 'sale_per_day_per_product') {
            data.customer_group_id = customerGroup;
        }

        if (isDateIntervalToLarge(from, to, maxDateInterval)) {
            alert(errorMessageTooLargeInterval)
            return;
        }
        data.from = from;
        data.to = to;
        data.sync_code = syncCode;
        if (scheduleReport) {
            data.email_recipient = $("input#excel_report_email_recipient").val();
            data.report_type = selectedReport;
        }

        ajaxLockActive = true;
        $.ajax({
            type: 'GET',
            url: ajaxPath,
            data,
            dataType: 'json'
        }).success(function (data) {
            if (scheduleReport) {
                modalParentElementInDOM = $('div#content');
                modalTitle = 'Repport bestilt!';
                modalMessage = 'Rapport sendes til ' + $("input#excel_report_email_recipient").val() + ' så snart den er klar.';
                modalAlertType = 'success';
                displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
            } else {
                downloadExcelFileFromReportFolder($.trim(data.excel_file_name));
            }
        }).error(function (data) {
            // Modal error message
            modalParentElementInDOM = $('div#content');
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';
            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        }).always(function () {
            ajaxLockActive = false;
        });
    });

    $("form#excel_report_form select#excel_report_type").change(function() {
       if ($('select#excel_report_type option:selected').val() == "sale_per_day_per_product") {
           $('form#excel_report_form div#export_customer_group_container').removeClass('hidden');
       } else {
           $('form#excel_report_form div#export_customer_group_container').addClass("hidden");
       }
    });

    /*if(ajaxLockActive) {
        return;
    }
    if (!$("div#accounting_export_wrapper div#exportHistoryWrapper").length) {
        return;
    }
    var from = $("form#eksport input#datofra").val();
    var to = $("form#eksport input#datotil").val();

    ajaxLockActive = true;
    $.ajax({
        type: 'GET',
        url: ajaxPathGetExportLogHtml,
        data: {
            from: from,
            to: to
        },
        dataType: 'json'
    }).success(function (data) {
        $("div#accounting_export_wrapper div#exportHistoryWrapper").html(data.html);
    }).error(function (data) {
        var error = $.parseJSON(data.responseText).errors;
        alert('Eksportlogg kunne ikke oppdateres. ' + error);
    }).always(function () {
        ajaxLockActive = false;
    });*/

    //export chosen data and format
    $(document).on('click', "div#accounting_export_wrapper button[name='eksport_button']", function (e) {

        if(ajaxLockActive) {
            return;
        }

        var from = $("form#eksport input#export_date_from").val();
        var to = $("form#eksport input#export_date_to").val();
        var eksportFormat = $("input[name='eksport_format']").val();
        var sumsTotalPeriod = $("input[name='sums_total_period']").val();
        var i = 0;
        var validDates = false;
        var validFormat = false;

        var fromArr = from.split('/');
        var fromDate = new Date();
        fromDate.setDate(fromArr[0]);
        fromDate.setMonth(fromArr[1] - 1);
        fromDate.setFullYear(fromArr[2]);

        var toArr = to.split('/');
        var toDate = new Date();
        toDate.setFullYear(toArr[2]);
        toDate.setMonth(toArr[1] - 1);
        toDate.setDate(toArr[0]);

        if (fromDate > toDate) {
            // If exported until 16/08/2016, the from date will say 17/08/2016 next time
            alert('Du har allerede eksportert til og med ' + to);
            return;
        }

        if (!confirm('NB! Ikke eksporter for dager der z-rapport ikke er tatt enda, disse dagene vil ikke bli inkludert i eksporten.\nEr Z-rapporter tatt til og med ' + $("form#eksport input#export_date_to").val() + '?')) {
            return;
        }

        if (typeof eksportFormat !== "undefined" && eksportFormat != '') {
            validFormat = true;
        }
        //Check that a valid date from and to is chosen
        if (from.split("/").length == 3 && to.split("/").length == 3) {
            validDates = isValidDates(from, to);
        }

        if (validDates && validFormat) {
            ajaxLockActive = true;
            $.ajax({
                type: 'GET',
                url: ajaxPathCreateAccountingExportFile,
                data: {
                    eksport_format: eksportFormat,
                    from: from,
                    to: to,
                    sums_total_period: sumsTotalPeriod
                },
                dataType: 'json'
            }).success(function (data) {
                window.location.replace("/force_download.php?path=" + $.trim(data.accounting_file_path));
                ajaxLockActive = false;
                updateExportLog();
            }).error(function (data) {
                modalTitle = 'Det oppstod en feil!';
                modalMessage = $.parseJSON(data.responseText).errors;
                modalAlertType = 'error';

                displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
            }).always(function () {
                ajaxLockActive = false;
            });

        } else {
            if (!validDates) {
                modalParentElementInDOM = $('div#content');
                modalTitle = 'Det oppstod en feil!';
                modalMessage = 'Velg gyldig fra og til-dato. Til-dato kan heller ikke være tidligere enn forrige eksport';
                modalAlertType = 'error';

                displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
            }

            if (!validFormat) {
                modalParentElementInDOM = $('div#content');
                modalTitle = 'Det oppstod en feil!';
                modalMessage = 'Ugyldig format på eksport.';
                modalAlertType = 'error';

                displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
            }
        }
    });

    function isValidDates(from, to) {
        var from = from.split("/");
        var to = to.split("/");
        if (from[2] + from[1] + from[0] > to[2] + to[1] + to[0]) {
            return false;
        }
        return true;
    }

    function isDateIntervalToLarge(from, to, maxDays) {
        var from = from.split("/");
        var to = to.split("/");
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date(from[2], from[1], from[0]);
        var secondDate = new Date(to[2], to[1], to[0]);

        var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
        if (diffDays > maxDays) {
            return true;
        }
        return false;
    }

    /*
     * Delete the latest export log
     */
    $(document).on('click', 'div#accounting_export_wrapper button.delete_export_log_button', function (event) {
        if(ajaxLockActive) {
            return;
        }

        if (!confirm('Vil du slette denne eksporten?')) {
            return;
        }
        ajaxLockActive = true;
        $.ajax({
            type: 'POST',
            url: defaultAjaxPath,
            data: {
                action: 'delete_export_log',
                export_log_id: $(this).closest('tr').attr('log_id')
            }
        }).done(function (response) {
            if ($.trim(response) === "1") {
                // Success
                // Refresh the log list
                ajaxLockActive = false;
                updateExportLog();
                alert('Eksport slettet');
            } else {
                alert('Det oppstod en feil under sletting');
            }
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', "div#accounting_export_wrapper a#choose_excel", function () {
        $("div#date_from_wrapper").show();
        if ($("input#export_date_from").is(":visible")) {
            // $("a[id='choose_excel']").html("Trykk her for &aring; ta vanlig eksport");
            $('#link_excel_export').remove();
            $("input[name='eksport_format']").val($("input[name='eksport_type_excel']").val());
            $("legend#accounting_header").html("Regnskapseksport Excel");
        } else {
            $("a[id='choose_excel']").html("Trykk her hvis du &oslash;nsker Excel eksport i stedet");
            $("input[name='eksport_format']").val($("input[name='eksport_format_extra']").val());
            $("legend#accounting_header").html("Regnskapseksport " + $("input[name='eksport_name_extra']").val());
        }
    });

    $(document).on('change', 'div#accounting_export_wrapper input#export_date_to', function () {
        var from = $("input#export_date_from").val();
        var to = $("input#export_date_to").val();

        if (!isValidDates(from, to)) {
            alert("Til-dato er satt til tidligere enn fra-dato.");
        }
    });


    //Get export history
    $(document).on('click', "div#accounting_export_wrapper button[name='getExportHistory']", function () {
        updateExportLog();
        return false;
    });

    /**
     * Updates the export log history table
     *
     * @returns {undefined}
     */
    function updateExportLog() {
        if(ajaxLockActive) {
            return;
        }
        if (!$("div#accounting_export_wrapper div#exportHistoryWrapper").length) {
            return;
        }
        var from = $("form#eksport input#datofra").val();
        var to = $("form#eksport input#datotil").val();

        ajaxLockActive = true;
        $.ajax({
            type: 'GET',
            url: ajaxPathGetExportLogHtml,
            data: {
                from: from,
                to: to
            },
            dataType: 'json'
        }).success(function (data) {
            $("div#accounting_export_wrapper div#exportHistoryWrapper").html(data.html);
        }).error(function (data) {
            var error = $.parseJSON(data.responseText).errors;
            alert('Eksportlogg kunne ikke oppdateres. ' + error);
        }).always(function () {
            ajaxLockActive = false;
            hidePreloader();
        });
    }

    /**
     * Opens new tab with excel file which forces download
     *
     * @param path
     */
    function downloadExcelFile(path) {
        if (path == '') {
            alert('Ingen data å eksportere');
        } else {
            window.location = '/includes/eksport/eksports/excel/' + path;
        }
        //window.location('/includes/eksport/eksports/excel/' + path, '_blank');
    }

    /**
     * Opens new tab with excel file which forces download
     *
     * @param path
     */
    function downloadExcelFileFromReportFolder(path) {
        if (path == '') {
            alert('Ingen data å eksportere');
        } else {
            window.location = '/includes/report/excels/' + path;
        }
        //window.location('/includes/eksport/eksports/excel/' + path, '_blank');
    }

    //Download export file if click on tr
    $(document).on('click', "div#accounting_export_wrapper div#exportHistoryWrapper table tr td", function (e) {
        if ($(this).hasClass('delete_td')) {
            // Dont download when clicking on the delete button
            return;
        }
        // Don't download when clicking on the checkbox or label
        if ($(e.target).closest('label.export_log_label').length) {
            return;
        }
        var tr = $(this).closest('tr');
        var url = tr.attr("id");
        window.location.replace("/force_download.php?path=includes/eksport/eksports/" + url);
    });

    //From
    $("input#export_date_from").datepicker({
        dateFormat: "dd/mm/yy"
    });

    //To
    $("input#export_date_to").datepicker({
        dateFormat: "dd/mm/yy"
    });

    function areCheckboxesSelectedSequentially(selector = 'input[type="checkbox"]') {
        const selectedIndexes = [];

        $(selector).each(function (index) {
            if ($(this).is(':checked')) {
                selectedIndexes.push(index);
            }
        });

        for (let i = 1; i < selectedIndexes.length; i++) {
            // Compare current index with previous + 1. If not equal, there is a gap in the sequence.
            if (selectedIndexes[i] !== selectedIndexes[i - 1] + 1) {
                return false;
            }
        }

        return true;
    }

    $(document).on('click', '#accounting_export_wrapper #export_logs_delete_button', function (e) {
        e.stopPropagation();

        if(ajaxLockActive) {
            return;
        }

        if (!confirm('Vil du slette disse eksportene?')) {
            return;
        }

        const exportLogIds = [];

        $('input.export_log_checkbox[type="checkbox"]:checked').each(function () {
            exportLogIds.push($(this).attr('log_id'));
        });

        if (exportLogIds.length === 0) {
            alert('Velg eksportlogger for sletting');
            return false;
        }
 
        if (!areCheckboxesSelectedSequentially('input.export_log_checkbox[type="checkbox"]')) {
            alert('Du har hull i den valgte listen. Velg alle eksportlogger mellom første og siste du valgte.');
            return false;
        }

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'DELETE',
            url: ajaxPathDeleteExportLogs,
            data: { ids: exportLogIds },
            dataType: 'json',
        }).success(function (data) {
            ajaxLockActive = false;
            updateExportLog();
            window.location.reload();
        }).error(function (data) {
            const error = $.parseJSON(data.responseText).errors;
            alert('Eksportlogger kunne ikke slettes. ' + error);
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('change', '#accounting_export_wrapper #export_logs_select_all', function (e) {
        const inputs = $('input.export_log_checkbox[type="checkbox"]:enabled');
        if ($(this).is(':checked')) {
            inputs.prop('checked', true);
        } else {
            inputs.prop('checked', false);
        }

        return false;
    });
});